import colors from "assets/theme/base/colors";
import { reportMolecularCompound } from "rest/requests";

function getQuarterIds(quarterIdMap) {
  const idQuarter1 = quarterIdMap[0];
  const idQuarter2 = quarterIdMap[1];
  const idQuarter3 = quarterIdMap[2];
  const idQuarter4 = quarterIdMap[3];
  return { idQuarter1, idQuarter2, idQuarter3, idQuarter4 };
}

class MolecularCompoundSummary {
  constructor(molecularCompoundName, color, id) {
    this.id = id;
    this.molecularCompoundName = molecularCompoundName;
    this.quarterSales1 = 0;
    this.quarterSales2 = 0;
    this.quarterSales3 = 0;
    this.quarterSales4 = 0;
    this.color = color != null ? color : "dark";
  }

  // Getter
  get total() {
    let total = this.quarterSales1 + this.quarterSales2 + this.quarterSales3 + this.quarterSales4;
    return total.toFixed(2);
  }
}

async function getDataPorPrincipioActivo(searchData, quarterIds) {
  const data = await reportMolecularCompound(searchData);
  let compound_names = [];
  let result = [];
  var color_list = Object.keys(colors.gradients);
  const { idQuarter1, idQuarter2, idQuarter3, idQuarter4 } = getQuarterIds(quarterIds);

  // get all MolecularCompounds
  data.forEach((elem) => {
    if (!compound_names.includes(elem.molecularCompoundName)) {
      compound_names.push(elem.molecularCompoundName);
    }
  });

  while (color_list.length <= compound_names.length) {
    color_list.push.apply(color_list, Object.keys(colors.gradients));
  }

  // build MolecularCompoundSummary per compound
  compound_names.forEach((name, index) => {
    var temp_compound = new MolecularCompoundSummary(name, color_list[index], index + 1);

    data.forEach((row) => {
      if (name === row.molecularCompoundName) {
        if (row.quarterId === idQuarter1) {
          temp_compound.quarterSales1 = row.sale;
        } else if (row.quarterId === idQuarter2) {
          temp_compound.quarterSales2 = row.sale;
        } else if (row.quarterId === idQuarter3) {
          temp_compound.quarterSales3 = row.sale;
        } else if (row.quarterId === idQuarter4) {
          temp_compound.quarterSales4 = row.sale;
        }
      }
    });

    result.push(temp_compound);
  });

  return result;
}

export default getDataPorPrincipioActivo;
